const toggleFilters = (trigger, filters) => {
    trigger.addEventListener('click', () => {
        if(trigger.getAttribute('data-filter-state') === 'collapsed') {
            trigger.setAttribute('data-filter-state', 'expanded');
            trigger.setAttribute('aria-expanded', 'true');
            trigger.querySelector('.filter-toggle__state').innerText = 'Less';
            filters.forEach((f) => {
                f.setAttribute('data-show', 'true');
            });
        }
        else {
            trigger.setAttribute('data-filter-state', 'collapsed');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.querySelector('.filter-toggle__state').innerText = 'More';
            filters.forEach((f) => {
                f.setAttribute('data-show', 'false');
            });
        }
    });
};

export {
    toggleFilters,
};
